// TODO: move to binary search (maybe)

export default function crop<Type>(
    arr: Type[],
    begin: number,
    end: number = Number.MAX_SAFE_INTEGER,
    property = 'timestamp'
): Type[] {
    if (arr.length > 0 && begin < end) {
        let cropStart = 0
        let cropEnd = arr.length - 1

        // Special case for when there is only one item in the list
        if (cropEnd === 0 && arr[0][property] > begin && arr[0][property] < end) {
            return [arr[0]]
        }

        while (cropStart < cropEnd && arr[cropStart][property] < begin) {
            cropStart++
        }

        while (cropStart < cropEnd && arr[cropEnd][property] > end) {
            cropEnd--
        }

        if (cropEnd === cropStart) {
            return cropEnd === 0 ? [] : [arr[cropEnd]]
        }

        if (cropStart > 0 || cropEnd < arr.length - 1) {
            return arr.slice(cropStart, cropEnd + 1)
        }
    }

    return arr
}
